export default [
  {
    mainFontFamily: 'Inter',
    displayFontFamily: 'Inter',
    id: '1'
  },
  {
    mainFontFamily: 'Open Sans',
    displayFontFamily: 'Roboto Slab',
    id: '2'
  },
  {
    mainFontFamily: 'Playfair Display',
    displayFontFamily: 'Playfair Display',
    id: '3'
  },
  {
    mainFontFamily: 'Open Sans',
    displayFontFamily: 'Galada',
    id: '4'
  }
];
